import { useQuery } from "@tanstack/react-query";
import { fetchStripeProducts } from "@common/lib/stripeProductsApi";
import type { ProductCatalog } from "@/features/admin/checkout/types";

export const stripeProductsQueryKey = ["stripe-products"] as const;

export function useStripeProducts(options?: { enabled?: boolean }) {
    return useQuery<ProductCatalog>({
        queryKey: stripeProductsQueryKey,
        queryFn: fetchStripeProducts,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        enabled: options?.enabled ?? true,
    });
}
